module.exports = __webpack_public_path__ + "static/img/7.289f77bb.png";